module.exports = __webpack_public_path__ + "static/illus_1-e8aacd5f3a137533d44852dd27ecfd95.png";